import { render, staticRenderFns } from "./SeriesSelection.vue?vue&type=template&id=812f4a32&scoped=true&"
import script from "./SeriesSelection.vue?vue&type=script&lang=js&"
export * from "./SeriesSelection.vue?vue&type=script&lang=js&"
import style0 from "./SeriesSelection.vue?vue&type=style&index=0&id=812f4a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812f4a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('812f4a32')) {
      api.createRecord('812f4a32', component.options)
    } else {
      api.reload('812f4a32', component.options)
    }
    module.hot.accept("./SeriesSelection.vue?vue&type=template&id=812f4a32&scoped=true&", function () {
      api.rerender('812f4a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/Includes/SeriesSelection.vue"
export default component.exports